import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import SQFTFeaturesHeader from '../menu/cabinet/toolMenu/commonParts/SQFTFeaturesHeader';
import LoadingSpinner from '../../../../ui/loadingSpinner';
import FeaturesGrid from '../menu/commonTools/featuresGrid/FeaturesGrid';
import { setSelectedFeatureInPicker } from '../../../../../actions/sqftMenuFunctions';
import {useSqftFeaturePickerRows} from "../hooks/useSqftFeaturePickerRows";

const SqftRightFeaturesGrid = (props) => {
  const {
    isMobile,
    windowHeight,
    groheFiltersSearchText,
    selectedFilters,
    featurePicker,
    setSelectedFeatureInPicker,
  } = props;

  const expanded = Boolean(featurePicker?.isOpen);

  const { featuresData, isLoading, headerPartId } = useSqftFeaturePickerRows({
    featurePicker,
    groheFiltersSearchText,
    selectedFilters,
  });

  const partIds = featurePicker?.partIds || [];
  const hasMultiplePartIds = partIds.length > 1;

  return (
    <div className={'content content--right side-level2--right' + (expanded ? ' expanded' : '')}>
      <div className={'side-level2__inner'}>
        <div className="side-level2__header-sticky">
          <SQFTFeaturesHeader headerTitle={' '} partId={headerPartId} />
        </div>

        <div className="side-level2__inner-withsidebar">
          {(Object.keys(featuresData) || []).map((partId) => {
            const featureData = featuresData[partId];

            // 2.) Enter feature click functionality here
            const itemClickCallback = (e, feature, parentFeature) => {
              void e;
              void parentFeature;

              setSelectedFeatureInPicker(feature.dbFeature.id);
            };

            const defaultActiveFeatureIndex = featureData && featureData.rows
              ? featureData.rows.findIndex(row => row.part.dbFeature.sharedFeatureName === featurePicker.sharedFeatureName)
              : 0;

            return (
              <React.Fragment key={partId}>
                {isLoading ? (
                  <LoadingSpinner />
                ) : (
                  featureData && (
                    <FeaturesGrid
                      partId={partId}
                      rows={featureData.rows}
                      defaultActiveFeatureIndex={defaultActiveFeatureIndex}
                      featureGroup={featureData.featureGroup}
                      isMobile={isMobile}
                      windowHeight={windowHeight}
                      itemClickCallback={itemClickCallback}
                      shouldShowFullHeight={hasMultiplePartIds}
                    />
                  )
                )}
              </React.Fragment>
            );
          })}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (store) => {
  const { menuOpened, featurePicker } = store.sqftMenuState;
  const { isMobile, windowHeight } = store.serverState;
  const { groheFiltersSearchText } = store.groheState;
  const { selectedFilters } = store.filterState;

  return {
    menuOpened,
    isMobile,
    windowHeight,
    groheFiltersSearchText,
    selectedFilters,
    featurePicker,
  };
};

export default injectIntl(connect(mapStateToProps, { setSelectedFeatureInPicker })(SqftRightFeaturesGrid));
